import { render, staticRenderFns } from "./ModuleTile.vue?vue&type=template&id=94516fda&scoped=true"
import script from "./ModuleTile.vue?vue&type=script&lang=js"
export * from "./ModuleTile.vue?vue&type=script&lang=js"
import style0 from "./ModuleTile.vue?vue&type=style&index=0&id=94516fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94516fda",
  null
  
)

export default component.exports